import { withTheme } from 'styled-components';
import CopyBlock from './components/CopyBlock';
export default withTheme(CopyBlock);
